import { useState } from 'react';
import { useKeyboard } from './useKeyboard';
import { api, ApiError } from '../api';

export function Activate({ onDone }: {
  onDone: (r: { deviceKey: string; terminalId: string; locationId: string; locationName: string }) => void;
}) {
  const [code, setCode] = useState('');
  const kb = useKeyboard(code, setCode, 'text');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true); setErr('');
    try {
      onDone(await api.activate({ code: code.trim().toUpperCase() }));
    } catch (e) {
      setErr(e instanceof ApiError && e.status === 404
        ? 'Код не подошёл. Проверьте и введите снова.'
        : 'Нет связи с сервером. Проверьте интернет.');
    } finally { setBusy(false); }
  };

  return (
    <div className="gate">
      <span className="eyebrow">Активация кассы</span>
      <h1>Введите код из бэк-офиса</h1>
      <p className="hint">Владелец создаёт устройство в офисе и получает код.</p>
      <input className="field"
            {...kb.props} placeholder="DSTR-XXXX-XXXX" value={code}
        autoCapitalize="characters" spellCheck={false}
        onChange={(e) => setCode(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && submit()} />
      <p className="error">{err}</p>
      {/* Форма НЕ знает формат кода: его выдаёт сервер, и в разных
          местах по-разному. Проверка формата на клиенте дважды подводила —
          сначала требовала ровно 14 символов, потом префикс DSTR.
          Здесь только «похоже на код», решает сервер */}
      <button className="btn accent" style={{ width: 'min(320px, 90vw)' }}
        disabled={busy || code.trim().length < 6} onClick={submit}>
        {busy ? 'Проверяем…' : 'Активировать'}
      </button>
      {kb.node}
    </div>
  );
}
